export default "__VITE_ASSET__CxrjOCTJ__"